export default "__VITE_ASSET__CNt$lT3X__"